package org.multiplatform.kotfolio.components

import androidx.compose.runtime.Composable
import org.multiplatform.kotfolio.models.Theme
import org.multiplatform.kotfolio.styles.InputStyle
import org.multiplatform.kotfolio.styles.MainButtonStyle
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.TextInput
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Composable
fun contactForm(breakpoint: Breakpoint) {
    val isDesktop = breakpoint >= Breakpoint.MD
    val inputWidth = if (isDesktop) 500.px else 100.percent

    Form(
        action = "https://formspree.io/f/xrgnaggn",
        attrs = Modifier
            .attrsModifier {
                attr("method", "POST")
            }
            .fillMaxWidth()
            .toAttrs(),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            // Name Field
            Label(
                attrs = Modifier
                    .classNames("form-label")
                    .margin(bottom = 8.px)
                    .color(Colors.White)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs(),
                forId = "inputName",
            ) {
                Text("Name")
            }

            Input(
                type = InputType.Text,
                attrs = InputStyle
                    .toModifier()
                    .id("inputName")
                    .classNames("form-control")
                    .margin(bottom = 20.px)
                    .width(inputWidth)
                    .backgroundColor(Color.rgba(255, 255, 255, 0.05f))
                    .color(Colors.White)
                    .border(1.px, org.jetbrains.compose.web.css.LineStyle.Solid, Color.rgba(255, 255, 255, 0.1f))
                    .borderRadius(8.px)
                    .padding(leftRight = 16.px, topBottom = 12.px)
                    .boxShadow(0.px, 0.px, 0.px, 0.px, null)
                    .attrsModifier {
                        attr("placeholder", "Full Name")
                        attr("name", "name")
                        attr("required", "true")
                    }
                    .toAttrs(),
            )

            // Email Field
            Label(
                attrs = Modifier
                    .classNames("form-label")
                    .margin(bottom = 8.px)
                    .color(Colors.White)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs(),
                forId = "inputEmail",
            ) {
                Text("Email")
            }
            Input(
                type = InputType.Email,
                attrs = InputStyle
                    .toModifier()
                    .id("inputEmail")
                    .classNames("form-control")
                    .margin(bottom = 20.px)
                    .width(inputWidth)
                    .backgroundColor(Color.rgba(255, 255, 255, 0.05f))
                    .color(Colors.White)
                    .border(1.px, org.jetbrains.compose.web.css.LineStyle.Solid, Color.rgba(255, 255, 255, 0.1f))
                    .borderRadius(8.px)
                    .padding(leftRight = 16.px, topBottom = 12.px)
                    .boxShadow(0.px, 0.px, 0.px, 0.px, null)
                    .attrsModifier {
                        attr("placeholder", "Email Address")
                        attr("name", "email")
                        attr("required", "true")
                    }
                    .toAttrs(),
            )

            // Message Field
            Label(
                attrs = Modifier
                    .classNames("form-label")
                    .margin(bottom = 8.px)
                    .color(Colors.White)
                    .fontWeight(FontWeight.Bold)
                    .toAttrs(),
                forId = "inputMessage",
            ) {
                Text("Message")
            }
            TextArea(
                attrs = InputStyle
                    .toModifier()
                    .id("inputMessage")
                    .classNames("form-control")
                    .margin(bottom = 32.px)
                    .height(150.px)
                    .width(inputWidth)
                    .backgroundColor(Color.rgba(255, 255, 255, 0.05f))
                    .color(Colors.White)
                    .border(1.px, org.jetbrains.compose.web.css.LineStyle.Solid, Color.rgba(255, 255, 255, 0.1f))
                    .borderRadius(8.px)
                    .padding(all = 16.px)
                    .boxShadow(0.px, 0.px, 0.px, 0.px, null)
                    .attrsModifier {
                        attr("placeholder", "Your Message")
                        attr("name", "message")
                        attr("required", "true")
                    }
                    .toAttrs(),
            )

            Box(
                modifier = Modifier.fillMaxWidth(),
                contentAlignment = Alignment.Center,
            ) {
                Button(
                    attrs = MainButtonStyle
                        .toModifier()
                        .height(48.px)
                        .minWidth(160.px)
                        .border(width = 0.px)
                        .borderRadius(r = 24.px)
                        .backgroundColor(Theme.Primary.rgb)
                        .color(Color.rgb(26, 10, 0)) // Dark text on gold button
                        .cursor(Cursor.Pointer)
                        .fontWeight(FontWeight.Bold)
                        .toAttrs(),
                ) {
                    Text("Submit")
                }
            }
        }
    }
}
